<template>
  <div class="honorModule">
    <normalModule :title="honorData.honorDesc.title">
      <div class="module-content" slot="main">
        <dl v-if="honorData.type == 9">
          <dt>{{ honorData.honorDesc.userName }}</dt>
          <dd>
            <img src="../../../assets/images/winterGame/jb.png" />
            {{ honorData.honorDesc.cupNumber }}
          </dd>
        </dl>
        <p class="acquire-time">{{ honorData.day }}获得</p>
        <p class="acquire-describe">
          {{ honorData.honorDesc.acquireDescribe }}
        </p>
      </div>
      <shareBtn :id="numbers" slot="footer" @shareClick="shareClick" />
    </normalModule>
  </div>
</template>

<script>
import normalModule from "./normalModule.vue";
import shareBtn from "@views/WinterGame/components/shareBtn.vue";
export default {
  name: "honorModule",
  components: {
    shareBtn,
    normalModule,
  },
  props: {
    honorData: {
      type: Object,
      default: null,
    },
    numbers: {
      type: String
    },
  },
  data() {
    return {};
  },
  methods: {
    shareClick() {
      this.$emit("shareClick", this.honorData);
    },
  },
};
</script>

<style lang="less" scoped>
.honorModule {
  dl {
    text-align: center;
    dt {
      height: 90px;
      font-size: 64px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #444b65;
      line-height: 90px;
    }
    dd {
      display: flex;
      justify-content: center;
      margin-left: 0;
      height: 56px;
      font-size: 40px;
      margin-top: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #444b65;
      line-height: 56px;
      img {
        width: 46px;
        height: 50px;
        margin-right: 12px;
      }
    }
  }

  .acquire-time {
    height: 40px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #68707d;
    line-height: 40px;
    text-align: center;
    margin: 0;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .acquire-describe {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #444b65;
    line-height: 44px;
    text-align: center;
    margin-left: 1.5em;
    margin-right: 1.5em;
    margin-top: 0;
    margin-bottom: 0;
    margin-bottom: 30px;
  }
}
</style>
